import { render } from "./wModelForm.vue?vue&type=template&id=79400ed0&ts=true"
import script from "./wModelForm.vue?vue&type=script&lang=ts"
export * from "./wModelForm.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__